import { useQuery } from "@tanstack/react-query";

import { quoteRequestWeightQuery } from "#modules/quoteRequests/infra/quoteRequestWeight.query";

export const useQuoteRequestWeight = (id: string | undefined, enabled: boolean) => {
  const { data, ...rest } = useQuery({
    ...quoteRequestWeightQuery(id, enabled),
  });

  return { quoteRequestWeight: data?.weight ?? 0, ...rest };
};
